import React, { useState } from "react";
import ReactECharts from "echarts-for-react";

import "./AnalysisCard.scss";
import { AnalysisCard } from "./AnalysisCard";
import { Api } from "../../common/Api";
import { fmtDate } from "../../common/Utils";

export const AppUser = () => {
  const [options, setOptions] = useState({
    xAxis: {
      type: "category",
      // boundaryGap: false,
      data: [],
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: [],
        type: "bar",
      },
    ],
  });
  const onStart = ({ interval, period }) => {
    Api.dashboard
      .analysisAppUser({
        interval,
        period: period.map((x) => x.toISOString()),
      })
      .then((res) => {
        console.log(res.data.analysisAppRating);
        const analysisAppUser = res.data.analysisAppUser;
        const xData = analysisAppUser.series[0].data.map((x) => fmtDate(x.key));
        const series = analysisAppUser.series.map((s) => {
          return {
            data: s.data.map((x) => x.value),
            type: "bar",
          };
        });
        let options2 = JSON.parse(JSON.stringify(options));
        options2.xAxis.data = xData;
        options2.series = series;
        setOptions({ ...options2 });
      });
  };

  return (
    <AnalysisCard title="App User" onStart={onStart}>
      <ReactECharts style={{ height: 400 }} option={options} />
    </AnalysisCard>
  );
};
